module.exports = __webpack_public_path__ + "static/media/noun-wifi-1254486-142350.b58b5e97.svg";